import { Action } from '@ngrx/store';

// Constants
export const GET_USER_NOTIFICATIONS = '[Core - NOTIFICATIONS] User Notifications';
export const GET_USER_NOTIFICATIONS_SUCCESS = '[Core - NOTIFICATIONS] User Notifications Success';
export const CHECK_USER_NOTIFICATIONS = '[Core - NOTIFICATIONS] Check User Notifications';


// Actions
export class GetUserNotifications implements Action {
  readonly type = GET_USER_NOTIFICATIONS;
}

export class GetUserNotificationsSuccess implements Action {
  readonly type = GET_USER_NOTIFICATIONS_SUCCESS;
  constructor(public payload: any){}
}

export class CheckUserNotifications implements Action {
  readonly type = CHECK_USER_NOTIFICATIONS;
}
// Export Actions
export type Actions =
  | GetUserNotifications
  | GetUserNotificationsSuccess
  | CheckUserNotifications  ;




// WEBPACK FOOTER //
// ./src/app/core/actions/notification.actions.ts